import React, { useState, useEffect, useRef, useMemo, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from 'redux/actions';
import ManageUser from './ManageUser';
import RectangularButton from 'components/elements/molecules/RectangularButton/RectangularButton';
import { withRouter } from 'react-router-dom';
import Switch from 'react-switch';

import './Users.scss';
import FloatingInput from 'components/elements/atoms/FloatingInput/FloatingInput';
import { Icon, ICONS } from 'components/Icons';
import { debounce } from 'throttle-debounce';
import DropDown from 'components/elements/atoms/DropDown/DropDown';
import TableColumnFilter from 'components/elements/organisms/TableColumnFilter/TableColumnFilter';
import { renderCheck } from 'routes/Portfolio/Component/ActivityTab/TopicsTab/helper';
import {
  renderExtensions,
  showExtensions,
} from 'routes/Admin/Users/helpers/getBrowserLogo';
import { Dropdown, MenuItem } from 'react-bootstrap';
import UserLevelGraph from 'components/elements/organisms/UserLevelGraph/UserLevelGraph';
import { Modal } from 'react-bootstrap';
import UserStatus from 'components/elements/molecules/UserStatusWithDetails/UserStatusWithDetailsPopover';

const extensionOptions = [
  { label: 'Safari Extension', value: 'Safari Extension' },
  { label: 'Chrome Extension', value: 'Chrome Extension' },
  { label: 'Firefox Extension', value: 'Firefox Extension' },
  { label: 'Mozilla Extension', value: 'Mozilla Extension' },
  { label: 'Microsoft Edge Extension', value: 'Microsoft Edge Extension' },
];

const roleOptions = [
  { label: 'Community', value: 'community' },
  { label: 'Creator', value: 'creator' },
  { label: 'Student', value: 'student' },
  { label: 'Teacher ', value: 'teacher' },
  { label: 'Admin', value: 'admin' },
  { label: 'School Administrator', value: 'schoolAdmin' },
  { label: 'Parent', value: 'parent' },
];

const viewOptions = [
  { label: 'Summary', value: 'summary' },
  { label: 'Activation report', value: 'activationReport' },
];

function Users({ actions, showLast10 = false, initialFilters = {}, history }) {
  const [isLoading, setIsLoading] = useState(false);
  const [skip, setSkip] = useState(10);
  const [search, setSearch] = useState('');
  const [users, setUsers] = useState([]);
  const [courses, setCourses] = useState([]);
  const [editingUser, setEditingUser] = useState(null);
  const [filters, setFilters] = useState({
    fromDate: null,
    endDate: null,
    courseId: [],
    extension: [],
    role: [],
    schoolId: [],
    withUnverifiedSchool: false,
    ...initialFilters,
  });
  const [view, setView] = useState(viewOptions[0]);
  const [schools, setSchools] = useState([]);

  const getMoreUsers = (search, resetUsers = false, skip = 0, limit = 10) => {
    const queryFilters = {
      ...filters,
      courseId: filters.courseId.map((i) => i.value).join(','),
      extension: filters.extension.join(','),
      role: filters.role.join(','),
      schoolId: filters.schoolId.map((i) => i.value).join(','),
      withUnverifiedSchool: filters.withUnverifiedSchool,
    };

    actions
      .getAdminUsers(search, queryFilters, skip, limit)
      .then((users) =>
        setUsers((currentUsers) => {
          if (resetUsers) {
            setSkip(10);
            return users;
          }

          return currentUsers.concat(users);
        }),
      )
      .catch(() => {})
      .finally(() => setIsLoading(false));
  };

  const getData = (search) => {
    console.log('get data', search);

    getMoreUsers(search, true);
  };

  let searchFunction = useRef(debounce(500, getData));

  useEffect(() => {
    return () => {
      if (searchFunction && searchFunction.current) {
        searchFunction.current.cancel();
      }
    };
  }, []);

  useEffect(() => {
    setIsLoading(true);

    getData(search, true);

    actions.getAdminCourses().then((courses) => setCourses(courses));
  }, [filters]);

  useEffect(() => {
    actions.getSchools().then(({ schools }) => setSchools(schools));
  }, []);

  const coursesOptions = useMemo(() => {
    const coursesClone = JSON.parse(JSON.stringify(courses));
    coursesClone.sort((a, b) => {
      return a.name.localeCompare(b.name);
    });

    const courseOptions = coursesClone.map((course) => ({
      label: course.name,
      value: course._id,
    }));

    return [...courseOptions];
  }, [courses]);

  const schoolsOptions = useMemo(() => {
    return schools
      .map((i) => ({ label: i.name, value: i._id }))
      .sort((a, b) => (a.label < b.label ? -1 : 1));
  }, [schools]);

  const handleSave = async (userId, roles, schools, subscriptions) => {
    await actions.updateUserRoles(userId, roles, schools, subscriptions);

    setEditingUser(null);

    getData();
  };

  const onVerifySchool = async (user, school) => {
    await actions.verifyUserSchool({
      username: user.username,
      schoolId: school.id,
    });
    getData();
  };

  function renderLoading() {
    return (
      <div className="text-center mt-4">
        <div
          className="fa fa-spin fa-spinner text-primary"
          style={{ fontSize: '40px' }}
        />
      </div>
    );
  }

  function renderUsers() {
    if (view.value === 'activationReport') {
      return (
        <React.Fragment>
          <div className="my-4 table-responsive">
            <table className="users-table bg-av-white">
              <thead>
                <tr>
                  <td rowSpan={2}>Username</td>
                  <td rowSpan={2} className="text-center">
                    Sign Up
                  </td>
                  <td rowSpan={2} className="text-center">
                    Verify email
                  </td>
                  <td rowSpan={2} className="text-center">
                    Set up account
                  </td>
                  <td colSpan={3} className="text-center">
                    Extension
                  </td>
                </tr>
                <tr>
                  <td className="text-center">Install</td>
                  <td className="text-center">Pin</td>
                  <td className="text-center">Log In</td>
                </tr>
              </thead>
              <tbody>
                <UsersFunnel users={users} />
              </tbody>
            </table>
          </div>
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <table className="my-4 table table-bordered bg-av-white">
          <thead>
            <tr>
              <th>Username</th>
              <th>Name</th>
              <th>Email</th>
              <th>
                <div className="d-flex align-items-center">
                  Roles {renderRoleFilter()}
                </div>
              </th>
              <th>School</th>
              <th>
                <div className="d-flex align-items-center">
                  Courses
                  {/* {renderCourseFilter()} */}
                </div>
              </th>
              <th>Browsers</th>
              <th>
                {' '}
                <div className="d-flex align-items-center">
                  Extensions
                  {renderExtensionFilter()}
                </div>
              </th>
              <th className="text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              renderLoading()
            ) : (
              <UserRows
                users={users.filter((user) => !user.unverified)}
                update={(user) => setEditingUser(user)}
                history={history}
                onVerifySchool={onVerifySchool}
                actions={actions}
                getData={getData}
              />
            )}
          </tbody>
        </table>
        {renderLoadMoreButtons()}
      </React.Fragment>
    );
  }

  const renderLoadMoreButtons = () => {
    if (showLast10) {
      return null;
    }

    return (
      <div className="d-flex align-items-center my-4">
        {users.length > 0 &&
          [10, 50, 100].map((numberOfUsers, index) => (
            <RectangularButton
              key={index}
              className="load-more-button mr-4 big-button"
              onClick={() => {
                setSkip(skip + numberOfUsers);
                getMoreUsers(search, false, skip, numberOfUsers);
              }}
              darkButton
              disabled={isLoading}
            >
              Load {numberOfUsers} More
            </RectangularButton>
          ))}
      </div>
    );
  };

  function renderManageUser() {
    if (!editingUser) {
      return null;
    }

    return (
      <ManageUser
        user={editingUser}
        handleSave={handleSave}
        getUserExtensionStatus={actions.getUserExtensionStatus}
        onClose={() => setEditingUser(null)}
        schoolsOptions={schoolsOptions}
      />
    );
  }

  const updateFilters = (filterBy, filterValue) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [filterBy]: filterValue,
    }));
  };

  const renderFilters = () => {
    if (showLast10) {
      return null;
    }

    return (
      <React.Fragment>
        <div className="mt-4">
          <div className="d-flex flex-shrink-0">
            <div className="users-filters mr-4">
              <DropDown
                className="view-dropdown"
                labelName="View"
                value={view}
                onChange={(selectedOption) => setView(selectedOption)}
                options={viewOptions}
                controlStyle={{ backgroundColor: 'transparent' }}
              />
            </div>
            <div className="date-container mr-4">
              <label className="date-label">From Date</label>
              <FloatingInput
                className="mb-0 ml-2 fromDate"
                value={filters.fromDate}
                placeholder="Date"
                onChange={(e) => updateFilters('fromDate', e.target.value)}
                type="date"
              />
            </div>
            <div className="date-container mr-4">
              <label className="date-label">End Date</label>
              <FloatingInput
                className="mb-0 ml-2 fromDate"
                value={filters.endDate}
                placeholder="Date"
                onChange={(e) => updateFilters('endDate', e.target.value)}
                type="date"
              />
            </div>
            <div className="d-inline-flex align-items-center">
              <Switch
                className="mx-3"
                offColor="#65737b"
                offHandleColor="#A4B4BD"
                onColor="#d5e7f4"
                onHandleColor="#1286C8"
                width={30}
                height={16}
                checkedIcon={false}
                uncheckedIcon={false}
                checked={filters.withUnverifiedSchool}
                onChange={(checked) => {
                  updateFilters('withUnverifiedSchool', checked);
                }}
              />
              <label className="mb-0">Unverified School</label>
            </div>
          </div>
          <div className="d-flex align-items-center mt-3">
            {renderSchoolsFilter()}
            {renderCourseFilter()}
          </div>
        </div>
        <FloatingInput
          className="w-50 search-input"
          value={search}
          placeholder="Search users by name, username, email here"
          onChange={(e) => {
            setSearch(e.target.value);

            searchFunction.current(e.target.value);
          }}
        >
          {search && (
            <Icon
              icon={ICONS.CLOSE}
              size={12}
              onClick={() => {
                setSearch('');

                searchFunction.current('');
              }}
            />
          )}
        </FloatingInput>
      </React.Fragment>
    );
  };

  function renderCourseFilter() {
    return (
      <DropDown
        className="course-dropdown flex-fill ml-4"
        labelName="Course"
        value={filters.courseId}
        onChange={(courseId) => {
          console.log(courseId);
          setFilters({ ...filters, courseId });
        }}
        options={coursesOptions}
        isMulti={true}
        controlStyle={{ backgroundColor: 'transparent' }}
      />
    );
  }

  const renderSchoolsFilter = () => {
    return (
      <DropDown
        className="course-dropdown flex-fill"
        labelName="School"
        value={filters.schoolId}
        onChange={(schoolId) => {
          setFilters({ ...filters, schoolId });
        }}
        options={schoolsOptions}
        isMulti={true}
        controlStyle={{ backgroundColor: 'transparent' }}
      />
    );
  };

  function renderRoleFilter() {
    if (showLast10) {
      return null;
    }

    return (
      <TableColumnFilter
        options={roleOptions}
        onChange={(role) => setFilters({ ...filters, role })}
        value={filters.role}
        single={false}
      />
    );
  }

  function renderExtensionFilter() {
    if (showLast10) {
      return null;
    }

    return (
      <TableColumnFilter
        options={extensionOptions}
        onChange={(extension) => setFilters({ ...filters, extension })}
        value={filters.extension}
        single={false}
      />
    );
  }

  return (
    <div className="admin-users-list">
      {/* <div className="font-weight-600">
        <Link to="/users">Users</Link> / All Users
      </div>
      <div className="d-flex align-items-center justify-content-between mt-4">
        <h2 className="title av-blue">All Users</h2>
      </div> */}
      {renderFilters()}
      {renderUsers()}
      {renderManageUser()}
    </div>
  );
}

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Users));

function UserRows({
  users,
  update,
  history,
  onVerifySchool,
  getData,
  actions,
}) {
  const [showUserLevelModal, setShowUserLevelModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(null);

  if (!Array.isArray(users) || users.length === 0) {
    return <div className="no-article">No users</div>;
  }

  const onViewArticles = (user) => {
    history.push(`/allArticles?user=${user.username}`);
  };

  const showExtensions = (siteInfo) => {
    if (
      !siteInfo ||
      !Array.isArray(siteInfo.extensions) ||
      siteInfo.extensions.length === 0
    ) {
      return null;
    }

    return siteInfo.extensions
      .filter(
        (extension) => typeof extension === 'string' || extension.extension,
      )
      .map((extension) => {
        if (typeof extension === 'string') {
          return extension;
        }

        return extension.extension;
      })
      .join(', ');
  };

  const showUser = (user) => {
    return (
      <tr key={user._id} className="article-container">
        <td>
          <div className="d-flex align-items-center">
            <div className="mr-1">
              <UserStatus user={user} />
            </div>
            {user.username}
          </div>
        </td>
        <td>{`${user.profile.firstName} ${user.profile.lastName}`}</td>
        <td>{user.email}</td>
        <td>{user.profile.roles.map((r) => r.type).join(', ')}</td>
        <td>
          {user.schools.map((i) => (
            <div className="text-nowrap">
              {i.name}
              {i.isVerified === false && (
                <a
                  className="ml-2 cursor-pointer text-underline"
                  onClick={() => {
                    onVerifySchool(user, i);
                  }}
                >
                  Verify
                </a>
              )}
            </div>
          ))}
        </td>
        <td>{Array.isArray(user.courses) ? user.courses.join(', ') : '-'}</td>
        <td>{user.siteInfo ? user.siteInfo.signUpBrowser : '-'}</td>
        <td>{showExtensions(user.siteInfo) || '-'}</td>
        <td className="text-center">
          <Dropdown
            id="schools-list-dropdown"
            pullRight
            className="more-menu"
            onClick={(e) => e.stopPropagation()}
          >
            <Dropdown.Toggle noCaret>
              <Icon icon={ICONS.MORE} className="m-0" />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <MenuItem onClick={() => update(user)}>Manage User</MenuItem>
              <MenuItem onClick={() => onViewArticles(user)}>
                View Articles
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setSelectedUser(user);
                  setShowUserLevelModal(true);
                }}
              >
                View User Level History
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setShowDeleteConfirmation({
                    userId: user._id,
                    type: 'permanent',
                  });
                }}
              >
                Permanently Delete
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setShowDeleteConfirmation({
                    userId: user._id,
                    type: 'anonymous',
                  });
                }}
              >
                Anonymously Delete
              </MenuItem>
            </Dropdown.Menu>
          </Dropdown>
        </td>
      </tr>
    );
  };

  const renderUserLevelModal = () => {
    if (!showUserLevelModal || !selectedUser) {
      return null;
    }

    return (
      <UserLevelGraphModal
        username={selectedUser.username}
        onClose={() => {
          setSelectedUser(null);
          setShowUserLevelModal(false);
        }}
      />
    );
  };

  const renderDeleteConfirmation = () => {
    if (!showDeleteConfirmation) {
      return null;
    }

    return (
      <DeleteAccountConfirmation
        type={showDeleteConfirmation.type}
        userId={showDeleteConfirmation.userId}
        onClose={() => setShowDeleteConfirmation(null)}
        actions={actions}
        getData={getData}
      />
    );
  };

  return (
    <Fragment>
      {users.map((user) => showUser(user))}
      {renderUserLevelModal()}
      {renderDeleteConfirmation()}
    </Fragment>
  );
}

function UsersFunnel({ users }) {
  if (!Array.isArray(users) || users.length === 0) {
    return <div className="no-article">No users</div>;
  }

  const showUser = (user) => {
    return (
      <tr key={user._id} className="article-container">
        <td>
          <div className="d-flex align-items-center">
            <div className="mr-1">
              <UserStatus user={user} />
            </div>
            {user.username}
          </div>
        </td>
        <td className="text-center">{renderCheck(true)}</td>
        <td className="text-center">
          {!user.unverified
            ? renderExtensions([user.siteInfo.signUpBrowser || '-'])
            : '-'}
        </td>
        <td className="text-center">
          {user.profile && user.profile.gettingStartedStatus === 'finished'
            ? renderExtensions([
                user.siteInfo.setupAccountBrowser ||
                  user.siteInfo.signUpBrowser ||
                  '-',
              ])
            : '-'}
        </td>
        <td className="text-center">
          {renderExtensions(showExtensions(user, 'installed', 'uninstallTime'))}
        </td>
        <td className="text-center">
          {renderExtensions(showExtensions(user, 'pinned', 'unpinnedTime'))}
        </td>
        <td className="text-center">
          {renderExtensions(showExtensions(user, 'login', 'loggedOutTime'))}
        </td>
      </tr>
    );
  };

  return users.map((user) => showUser(user));
}

function DeleteAccountConfirmation({
  userId,
  type,
  getData,
  actions,
  onClose,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [showConfirmationMessage, setShowConfirmationMessage] = useState(false);

  async function deleteUser() {
    setIsLoading(true);

    if (type === 'permanent') {
      try {
        await actions.permanentDeleteUser(userId);
        getData();
        setShowConfirmationMessage(true);
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }

      return;
    }

    try {
      await actions.anonymizeUserData(userId);
      getData();
      setShowConfirmationMessage(true);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <Modal show className="delete-account-modal">
      <Modal.Header closeButton={true} onHide={onClose}>
        <Modal.Title>Delete account</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {showConfirmationMessage ? (
          <div>
            User account and data will be{' '}
            {type === 'permanent' ? 'deleted' : 'anonymized'} and user will be
            notified via an email.
          </div>
        ) : (
          <div>
            Are you sure you want to{' '}
            {type === 'permanent' ? 'delete' : 'anonymize'} user's account and
            data? This will {type === 'permanent' ? 'delete ' : 'anonymize '}
            user and all associated data. This action cannot be reversed.
          </div>
        )}
      </Modal.Body>
      {!showConfirmationMessage && (
        <Modal.Footer>
          <div className="d-flex justify-content-end">
            {isLoading ? (
              <div
                className="fa fa-spin fa-spinner text-primary"
                style={{ fontSize: '18px' }}
              />
            ) : (
              <>
                <RectangularButton onClick={() => onClose()} noBorder>
                  No, keep account
                </RectangularButton>
                <RectangularButton
                  onClick={() => deleteUser()}
                  className="danger-button"
                  darkButton
                >
                  Yes, delete account
                </RectangularButton>
              </>
            )}
          </div>
        </Modal.Footer>
      )}
    </Modal>
  );
}

export function UserLevelGraphModal({ username, onClose }) {
  return (
    <Modal show className="">
      <Modal.Header>
        <Modal.Title>
          User Level History
          <Icon
            icon={ICONS.CLOSE}
            className="pull-right cursor-pointer"
            onClick={onClose}
          />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <UserLevelGraph username={username} />
      </Modal.Body>
    </Modal>
  );
}
